import ActionBase, { ACTION_TYPES } from './ActionBase.js';
import Store from '../../Store.js';

/**
 * @module Core/data/stm/action/RemoveAllAction
 */

/**
 * Action to record a store "remove all" operation.
 * @extends Core/data/stm/action/ActionBase
 */
export default class RemoveAllAction extends ActionBase {
    static $name = 'RemoveAllAction';

    static configurable = {
        /**
         * Reference to cleared store
         *
         * @prp {Core.data.Store}
         * @readonly
         * @default
         */
        store : undefined,

        /**
         * All store records removed
         *
         * @prp {Core.data.Model[]}
         * @readonly
         * @default
         */
        allRecords : undefined,

        /**
         * Flag showing if undo/redo should be done silently i.e. with events suppressed
         *
         * @prp {Boolean}
         * @readonly
         * @default
         */
        silent : false
    };

    get type() {
        return ACTION_TYPES.REMOVE_ALL;
    }

    //<debug>
    afterConfig() {
        super.afterConfig();

        console.assert(
            this.store instanceof Store,
            Array.isArray(this.allRecords) &&
            this.allRecords.length &&
            this.allRecords.every(m => m.isModel),
            "Can't create action, bad configuration!"
        );
    }
    //</debug>

    changeStore(store) {
        //<debug>
        console.assert(
            !this._store && store && store instanceof Store,
            "Can't set store, store is required and can be set only once!"
        );
        //</debug>

        return store;
    }

    changeAllRecords(records) {
        //<debug>
        console.assert(
            !this._allRecords &&
            Array.isArray(records) &&
            records.length,
            records.every(m => m.isModel),
            "Can't all records list, all records list is required it should be array of Models and it can be set only once!"
        );
        //</debug>

        return records.slice(0);
    }

    undo() {
        const { store, allRecords, silent } = this;
        store.add(allRecords, silent);
    }

    redo() {
        this.store.removeAll(this.silent);
    }
}
